import { createdATFilter } from 'modules/common/constants';

export const reportCauseFilters = [createdATFilter];
